export const VideoTab = {
  ALL: 'all',
  WATCHED: 'watched',
  UNWATCHED: 'unwatched',
  SEARCH: 'search',
};
